module.exports = new __parcel__URL__("tone.148f2b48.gif").toString();